import { CHART_ELEMENT_ID } from 'finviz-charts/app/constants/common'
import ReactDOM from 'react-dom'

import { SpecificChartFunctionality, TIMEFRAME } from '../../main/constants'
import { ChartLayoutWithGlobalState, FREE_DATE_RANGES, Theme } from '../charts-lib'
import { decodeQueryString } from '../queryString'
import { getChartLayoutSizeConfig, useChartLayoutWidthWatch } from './hooks/use-chart-layout-width-watch'

export function QuoteChart() {
  useChartLayoutWidthWatch()
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  const chartConfig = window.globalChartConfig
  const theme = FinvizSettings.hasDarkTheme ? Theme.dark : Theme.light

  if (chartEl && chartConfig) {
    const { p = FinvizSettings.defaultPeriod as TIMEFRAME } = decodeQueryString<{ p?: TIMEFRAME }>()
    return ReactDOM.createPortal(
      <ChartLayoutWithGlobalState
        config={{
          ...chartConfig,
          ...getChartLayoutSizeConfig(chartConfig, p),
          specificChartFunctionality: SpecificChartFunctionality.quotePage,
          charts: chartConfig.charts.map((chart) => ({
            ...chart,
            dateRange:
              FinvizSettings.hasUserPremium || FREE_DATE_RANGES.includes(chart.dateRange ?? '')
                ? chart.dateRange
                : null,
          })),
          theme,
        }}
        parentElement={chartEl}
      />,
      chartEl
    )
  }
  return null
}
